export const MSG_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  DEFAULT: 'default',
};

export const OUTLETS_MAP_CONTEXT = {
  FOR_BAKERY: 'FOR_BAKERY',
  FOR_CITY: 'FOR_CITY'
};

export const ASPECT_RATIO_IDS = {
  ROUND: 'ROUND',
  SQUARE: 'SQUARE',
  RECT_VERTICAL: 'RECT_VERTICAL',
  RECT_HORIZONTAL: 'RECT_HORIZONTAL',
  RECT_HORIZONTAL_LONG: 'RECT_HORIZONTAL_LONG',
};

export enum ASPECT_RATIO_CLASSES {
  ROUND = 'round-icon',
  SQUARE = '',
  RECT_VERTICAL = 'rect-vertical',
  RECT_HORIZONTAL = 'rect-horizontal',
  RECT_HORIZONTAL_LONG = 'rect-horizontal-long'
}

export const A4_ASPECT_RATIO: number = 1.414285724285724;

export const DEFAULT_ASPECT_RATIOS: IAspectRatioInfo[] = [
  { ratio: 1, isCircle: true, iconClass: ASPECT_RATIO_CLASSES.ROUND, id: ASPECT_RATIO_IDS.ROUND },
  { ratio: 1, isCircle: false, iconClass: ASPECT_RATIO_CLASSES.SQUARE, id: ASPECT_RATIO_IDS.SQUARE },
  {
    ratio: A4_ASPECT_RATIO,
    isCircle: false,
    iconClass: ASPECT_RATIO_CLASSES.RECT_VERTICAL,
    id: ASPECT_RATIO_IDS.RECT_VERTICAL
  },
  {
    ratio: 1 / A4_ASPECT_RATIO,
    isCircle: false,
    iconClass: ASPECT_RATIO_CLASSES.RECT_HORIZONTAL,
    id: ASPECT_RATIO_IDS.RECT_HORIZONTAL
  },
];

export interface IAspectRatioInfo {
  id?: string;
  ratio: number;
  iconClass: ASPECT_RATIO_CLASSES;
  isCircle: boolean;
}

export const PRODUCT_TYPE_SHAPES = {
  ROUND: 'ROUND',
  SQUARE: 'SQUARE',
  OVAL: 'OVAL',
  RECTANGLE: 'RECTANGLE',
  TWO_LEVEL_ROUND: 'TWO-LEVEL-ROUND',
  THR_LEVEL_ROUND: 'THR-LEVEL-ROUND',
  FOR_LEVEL_ROUND: 'FOR-LEVEL-ROUND'
};

export const CUSTOM_NOTE_COLOR_MAP = {
  PRIMARY: 'badge-primary',
  SECONDARY: 'badge-pink'
};

export const IMAGE_MB_SIZE_LIMIT = 21348301;

export const CROPPED_IMAGE_MAX_SIZE_PX = 1024;
export const MOTIVE_MAX_IMAGE_SIZE_PX = 1500;
